import {
	Alert,
	Button,
	Checkbox,
	Divider,
	Grid,
	PasswordInput,
	Text,
	TextInput,
} from "@mantine/core";
import { Form } from "@remix-run/react";
import { IconAlertCircle } from "@tabler/icons-react";
import { useState } from "react";
import { PrivacyTermsDialog } from "./privacy-terms-dialog";

type Props = {
	loading?: boolean;
	formErrors?: string[];
	errors?: {
		company?: string[];
		vat?: string[];
		email?: string[];
		firstName?: string[];
		lastName?: string[];
		password?: string[];
		passwordConfirmation?: string[];
		privacyPolicy?: string[];
	};
};

export const BrandRegistrationForm = ({
	formErrors,
	errors,
	loading,
}: Props) => {
	const [policyOpen, setPolicyOpen] = useState<boolean>(false);
	const [privacyPolicyAccepted, setPrivacyPolicyAccepted] =
		useState<boolean>(false);

	return (
		<Form method="post">
			<input type="hidden" name="action" value="brand" />
			<Grid mt={36}>
				<Grid.Col md={6}>
					<TextInput
						name="company"
						label="Company name"
						placeholder="Company name"
						error={errors?.company?.[0]}
					/>
				</Grid.Col>
				<Grid.Col md={6}>
					<TextInput
						name="vat"
						label="VAT number"
						placeholder="VAT Number"
						error={errors?.vat?.[0]}
					/>
				</Grid.Col>
				<Grid.Col>
					<Text weight={600}>Contact person</Text>
				</Grid.Col>
				<Grid.Col md={6}>
					<TextInput
						name="firstName"
						label="First name"
						placeholder="First name"
						error={errors?.firstName?.[0]}
					/>
				</Grid.Col>
				<Grid.Col md={6}>
					<TextInput
						name="lastName"
						label="Last name"
						placeholder="Last name"
						error={errors?.lastName?.[0]}
					/>
				</Grid.Col>
				<Grid.Col md={6}>
					<TextInput
						type="email"
						name="email"
						label="Email address"
						placeholder="Email address"
						error={errors?.email?.[0]}
					/>
				</Grid.Col>
				<Grid.Col md={6}>
					<TextInput label="Phone number" name="phoneNumber" />
				</Grid.Col>
				<Grid.Col>
					<PasswordInput
						name="password"
						label="Create password"
						placeholder="Create password"
						error={errors?.password?.[0]}
					/>
				</Grid.Col>
				<Grid.Col>
					<PasswordInput
						name="passwordConfirmation"
						label="Confirm password"
						placeholder="Confirm password"
						error={errors?.passwordConfirmation?.[0]}
					/>
				</Grid.Col>
			</Grid>
			<Divider my="xl" />
			<Checkbox
				defaultChecked
				name="followUp"
				label="I would like a callback from a TJJS sales representative and a Demo"
			/>
			<Checkbox
				name="privacyPolicy"
				checked={privacyPolicyAccepted}
				onClick={() => {
					setPolicyOpen(true);
				}}
				mt="md"
				error={errors?.privacyPolicy?.[0]}
				onChange={() => {}}
				label={
					<>
						I have read and acknowledged the{" "}
						<Text component="span" weight={600}>
							Privacy Policy
						</Text>{" "}
						and the{" "}
						<Text component="span" weight={600}>
							Terms and conditions
						</Text>
					</>
				}
			/>

			{policyOpen && (
				<PrivacyTermsDialog
					onClose={() => setPolicyOpen(false)}
					onAccept={() => {
						setPrivacyPolicyAccepted(true);

						setPolicyOpen(false);
					}}
				/>
			)}

			{formErrors?.length ? (
				<Alert color="red" mt="md" icon={<IconAlertCircle size={16} />}>
					{formErrors[0]}
				</Alert>
			) : null}

			<Button loading={loading} fullWidth type="submit" color="green" mt={36}>
				Create account
			</Button>
		</Form>
	);
};
